import action from '../helpers/rest-client'
import axios from 'axios'
import services from '.'

export class ErrorEnargas extends Error { }

class Enargas {
  public getEntity({ filters }) {
    const { type, ...rest } = filters
    const filtersJSON = rest ? `?filters=${JSON.stringify(rest)}` : '';
    console.log('getEntity', filtersJSON)
    return action
      .Get({
        url: `/enargas/${type}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async migrateEntity({ filters }) {
    // Validar que filters exista
    if (!filters) {
      console.error('migrateEntity: filters is undefined');
      return { error: 'Filters is required' };
    }

    const { type, ...rest } = filters

    // Validar que type exista
    if (!type) {
      console.error('migrateEntity: type is undefined in filters');
      return { error: 'Entity type is required' };
    }

    const params = new URLSearchParams();

    console.log("migrateEntity service", filters)

    if (rest && Object.keys(rest).length > 0) {
      params.append('filters', JSON.stringify(rest));
    }

    const queryString = params.toString();
    const url = `/enargas/${type}/migrate${queryString ? `?${queryString}` : ''}`;

    console.log('migrateEntity URL:', url);

    try {
      const token = services.auth.getToken();
      const baseURL = process.env.REACT_APP_API_URL || "/";

      const response = await axios.get(url, {
        baseURL,
        headers: {
          authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });

      console.log('migrateEntity response type:', typeof response.data);
      console.log('migrateEntity response instanceof Blob:', response.data instanceof Blob);

      return { response: response.data }
    } catch (error) {
      console.error('migrateEntity error:', error);
      return { error }
    }
  }
}

const enargas = new Enargas()
export default enargas
